module.exports = __webpack_public_path__ + "img/download_ios_qr.f60aa73c.png";